<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img border-light"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
        ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
        width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }"
        *ngIf="control.elementVal.getValue()?.txtId > 0">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }"
        *ngIf="!(control.elementVal.getValue()?.txtId > 0)">
            {{ control.elementVal.getValue()?.params.dayId | weekDay }}
    </h2>
    <div class="control__arrows">
        <img ngSrc="/assets/img/icons/arrows.svg"
            width="40" height="40" alt="" />
    </div>
    <div class="control__content">
        <div class="time-table" data-testid="time-table">
            <div class="time-table__wrapper">
                <div class="time-table__item"
                    *ngFor="let val of schedule.scheduleTable; trackBy:itemIndex; let idx = index">
                    <div class="time-table__rotate">
                        <p class="time-table__hour color-basic font-12">
                            {{ idx }}
                        </p>
                        <span class="color-basic font-12">:00</span>
                    </div>
                    <input class="time-table__input cursor-pointer"
                        type="range"
                        min="{{ schedule.scheduleMin }}"
                        max="{{ schedule.scheduleMax }}"
                        value="{{ schedule.scheduleTable[idx] }}"
                        [(ngModel)]="schedule.scheduleTable[idx]" />
                    <div class="time-table__rotate">
                        <p class="time-table__value color-basic font-12 ">
                            {{ val }}
                        </p>
                        <span class="color-basic font-12">&deg;</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="control__checkbox-weekday "
            *ngFor="let value of control.brotherElement | orderById">
            <label class="color-basic cursor-pointer">
                <span class="control__checkbox-weekday-name"
                    [ngClass]="{ 'font-bold': value.id === control.elementVal.getValue()?.id }">
                    {{ value.params.dayId | weekDay }}
                </span>
                <input class="control__checkbox-weekday-input cursor-pointer"
                    type="checkbox"
                    [disabled]="value.id === control.elementVal.getValue()?.id"
                    [(ngModel)]="value.checked">
            </label>
        </div>
    </div>

    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="schedule.setScheduleTable('default')">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="schedule.returnScheduleTable()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.id > 0"
        class="control__during-change">
        <p class="color-alarm font-18"
            *ngIf="control.elementVal.getValue()?.duringChange === 't'">
            {{ subtitle(3162) }}
        </p>
    </div>
</div>
